<script setup>
import { computed } from 'vue'
import { urlFromAWSUrl } from '@/imagekit/imageurl_from_aws_url'
import IKImageS3Wrapper from '@/imagekit/IKImageS3Wrapper.vue'

const s3BucketUrl = "https://s3.amazonaws.com/bankresources.goalbookapp.com/book-buddies/2017-01-31_20%3A56-Book+Buddies.jpg"
const cloudfrontUrl = "https://d14w9elxmqt4gn.cloudfront.net/adaptations/reinforcers/2016-08-02_04:24-reinforcers.jpg"
const ikUrl = computed(() => urlFromAWSUrl(s3BucketUrl, [{ w: 384, h: 256, e: "grayscale" }]))

</script>

<template>
  <div>
    <h1 class="header-xl w-fit">Hello GB Engineers. Welcome to Vue 3!</h1>
    <div class="w-96 h-64 bg-cover" :style="{backgroundImage: `url('${ikUrl}')`}"><p class="bg-purple-4/50 text-white">An S3 Bucket Background Image</p></div>
    <IKImageS3Wrapper :aws-url="cloudfrontUrl" :transformation="[{rotation: 90}]" />
  </div>
</template>

<style scoped></style>
